export default {
  guides: {
    sectionTitle: "Guías detalladas de USFans",
    sectionSubtitle: "Diez guías prácticas que cubren desde comprar con seguridad hasta envíos, cupones, legitimidad y privacidad.",
    readMore: "Leer la guía",
    items: [
      {
        title: "Guía de compras de USFans: cómo comprar con confianza",
        desc: "Un recorrido paso a paso para navegar por USFans, elegir el producto adecuado y completar una compra con seguridad.",
      },
      {
        title: "Hoja de cálculo de USFans: la guía completa",
        desc: "Entiende qué es la hoja de cálculo de USFans, cómo funcionan sus categorías y cómo navegar por ella rápidamente.",
      },
      {
        title: "Reseña de USFans: funciones, pros y contras",
        desc: "Una mirada honesta a las funciones de la plataforma, sus ventajas, limitaciones y lo que debes vigilar.",
      },
      {
        title: "Costo de envío de USFans: guía completa de precios",
        desc: "Conoce qué factores influyen en los precios de envío y cómo estimar los costos de entrega para tu región.",
      },
      {
        title: "Cupón de USFans: cómo encontrar ofertas reales",
        desc: "Una guía práctica para encontrar promociones auténticas y entender cómo funcionan los cupones de USFans.",
      },
      {
        title: "Código de descuento de USFans: cómo verificar ofertas",
        desc: "Cómo comprobar si un código de descuento es válido antes de pagar y evitar ofertas vencidas o falsas.",
      },
      {
        title: "Almacén de USFans: guía de almacenamiento y envío",
        desc: "Todo lo que necesitas saber sobre el almacenamiento, el procesamiento de pedidos y los plazos de entrega.",
      },
      {
        title: "¿Es legítimo USFans? Qué saber antes de comprar",
        desc: "Cómo evaluar la legitimidad, la confianza y las señales de seguridad antes de hacer un pedido.",
      },
      {
        title: "Seguridad de USFans: protege tu cuenta y privacidad",
        desc: "Recomendaciones prácticas para mantener seguros tu cuenta, tus pagos y tu información personal.",
      },
      {
        title: "Privacidad de USFans: cómo se manejan tus datos",
        desc: "Una visión clara de las consideraciones de privacidad y cómo proteger tu información personal al comprar.",
      },
    ],
    detail: {
      pointsTitle: "Qué tener en cuenta",
      points: [
        "Verifica siempre los precios, tallas y disponibilidad actuales en la tienda principal antes de comprar.",
        "Revisa el costo de envío y la entrega estimada para tu región específica.",
        "Confirma cualquier cupón o código de descuento directamente al pagar antes de confiar en él.",
        "Usa fuentes oficiales o de confianza y protege tu información personal y de pago.",
      ],
      relatedTitle: "Más guías de USFans",
      visitMain: "Visitar el sitio principal",
      backHome: "Volver al inicio",
    },
  },
};